<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>
                    CONVERSA
                    
                    <b-button 
                        variant="danger" 
                        class="float-right ml-2" 
                        @click="finalizarConversa"
                        v-if="conversa.status != 3 && this.$store.getters.fornecedor.fornecedorId == null"
                    >
                        <i class="fa fa-check-circle mr-2"></i>Finalizar Conversa
                    </b-button>
                    <app-btn-voltar class="float-right ml-2" rota="Mensagens" variant="secondary"></app-btn-voltar>
                </h5>
            </b-card-header>

            <b-card-body>
                <b-row>
                    <b-col sm="12">
                        <label>Remetente</label>
                        <b-card no-body class="mb-3">
                            <b-card-body>
                                
                                    <app-k-v titulo="Enviada por" :md="3" :lg="2" :xl="1" :dado="conversa.criadaPor"></app-k-v>
                                    <app-k-v titulo="Enviada em" :md="3" :lg="2" :xl="1" :dado="formatarData(conversa.dataCriacao)"></app-k-v>
                                    <app-k-v titulo="Status" :md="3" :lg="2" :xl="1" :dado="conversa.statusDescr"></app-k-v>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        @click="mostrarDestinatarios"
                                        
                                    >
                                        <i class="fa fa-users mr-1"></i> Ver Destinatários
                                    </b-button>
                                
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                        <label>Assunto</label>
                        <b-form-input
                            type="text"
                            v-model="conversa.assunto"
                            :disabled="true"
                            class="mb-3"
                        ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div class="messages-container">
                    <b-list-group>
                        <b-list-group-item 
                            v-for="item in mensagensOrdenadas" 
                            :key="item.conversaMensagemId"
                            :class="[
                                'mb-2 border-0 bg-transparent',
                                isCurrentUser(item.mensagem.usuarioIdCriacao) ? 'message-right' : 'message-left'
                            ]"
                        >
                            <div class="message-content">
                                <div class="message-header">
                                    <strong >{{ item.mensagem.criadaPor || 'Fornecedor' }}</strong>
                                   
                                    <small class="text-muted  ml-2">{{ formatarData(item.mensagem.dataCadastro) }}</small>
                                </div>
                                <div class="message-body">
                                  
                                    <div v-html="item.mensagem.conteudo"></div>
                                </div>
                                <div class="message-status" v-if="item.mensagem.status == 1">
                                    <small class="text-success">
                                        <i class="fa fa-check"></i><i class="fa fa-check"></i> Enviada
                                    </small>
                                </div>
                                <div class="message-status" v-if="item.mensagem.status == 0">
                                    <small class="text-secondary">
                                        <i class="fa fa-check"></i> Rascunho
                                    </small>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>

                
                 <b-form @submit.prevent="enviarMensagem" class="mt-3" v-if="conversa.status != 3"> 
                    <b-input-group>
                        <b-form-textarea 
                            v-model="novaMensagem.conteudo" 
                            placeholder="Digite sua mensagem..." 
                            rows="2"
                            max-rows="2"
                        ></b-form-textarea>
                        <b-input-group-append>
                            <b-button 
                                type="submit" 
                                variant="primary"
                                :disabled="!habilitarEnviar"
                            >
                                Enviar
                                <i class="fa fa-paper-plane ml-2"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form>
                
                <div v-if="conversa.status == 3" class="text-muted mt-3 text-center">
                    <i class="fa fa-lock mr-2"></i>Esta conversa está concluída
                </div>
            </b-card-body>
        </b-card>

        <b-modal
    id="modal-destinatarios"
    title="Destinatários da Conversa"
    ok-only
    ok-title="Fechar"
    size="lg"
    centered
    class="destinatarios-modal"
>
            <p>{{ formatarDestinatarios }}</p>
        </b-modal>
    </div>
</template>

<script>
import MensagensServicos from './MensagensServicos'
import { required, email } from 'vuelidate/lib/validators'
import Cabecalho from './Cabecalho'
export default {
    name: 'ConversaDetalhes',
    components: { Cabecalho },
    data() {
        return {
            conversa: {
                assunto: '',
                conversaMensagem: []
            },
            novaMensagem: {
                assunto: '',
                conteudo: ''
            },
            loading: false,
            currentUserId: "" 
        }
    },

    computed: {
        formatarDestinatarios() {
            if (!this.conversa.destinatarios?.length) return 'Nenhum destinatário'
            return this.conversa.destinatarios
                .map(d => d.razaoSocial || d.nome)
                .join(',  ')
        },
        habilitarEnviar() {
            return !this.$v.$invalid
        },
        
        mensagensOrdenadas() {
            if (!this.conversa.conversaMensagem) return []
            
            return [...this.conversa.conversaMensagem].sort((a, b) => {
                const dateA = new Date(a.mensagem.dataCadastro)
                const dateB = new Date(b.mensagem.dataCadastro)
                return dateA - dateB
            })
        }
    },
    validations: {
        novaMensagem: {
            conteudo: {
                required
            }
        }
    },

    methods: {
        async carregarConversa() {
            try {
                this.$store.dispatch('addRequest');
                this.loading = true
                const conversaId = this.$route.params.conversaId
                const response = await MensagensServicos.obterMensagensConversa(conversaId)

                if (response && response.success) {
                    this.conversa = response.data
                    this.novaMensagem.assunto = `RE: ${this.conversa.assunto}`
                } else {
                    this.$bvToast.toast('Erro ao carregar a conversa', {
                        title: 'Erro',
                        variant: 'danger'
                    })
                }
            } catch (error) {
              
            } finally {
                this.loading = false
            }
            this.$store.dispatch('removeRequest')
        },

        async enviarMensagem() {
            if (!this.novaMensagem.conteudo.trim()) return

            const conversaId = this.$route.params.conversaId
            let mensagemDto = {
                conversaId: conversaId,
                assunto: this.novaMensagem.assunto,
                conteudo: this.novaMensagem.conteudo,
                Status: 1,
                UsuarioIdEnvio: this.$store.getters.usuario.usuarioId
                
            }
            
            this.$store.dispatch('addRequest');
            MensagensServicos.salvarMensagem(mensagemDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Mensagem salva com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        const novaMensagemObj = {
                            conversaMensagemId: response.data, 
                            conversaId: conversaId,
                            mensagem: {
                                mensagemId: response.data,
                                usuarioIdCriacao: this.$store.getters.usuario.usuarioId,
                                usuarioIdEnvio: this.$store.getters.usuario.usuarioId,
                                criadaPor: this.$store.getters.usuario.nome,
                                assunto: this.novaMensagem.assunto,
                                conteudo: this.novaMensagem.conteudo,
                                dataCadastro: new Date().toISOString(),
                                dataEnvio: new Date().toISOString(),
                                status: 1,
                                statusDescr: 'ENVIADA',
                                leituraStatus: 0
                            }
                            
                        }
                       
                        this.conversa.conversaMensagem.push(novaMensagemObj)
                        this.novaMensagem.conteudo = ''

                        this.$nextTick(() => {
                            const container = document.querySelector('.messages-container')
                            container.scrollTop = container.scrollHeight
                        })
                    } else {
                        this.$toast.error(
                            'Erro ao salvar mensagem!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        async AtualizarConversa() {
        try {
            const conversaId = this.$route.params.conversaId
            
           
            if (!this.conversa || this.conversa.status === undefined) {
                const response = await MensagensServicos.obterMensagensConversa(conversaId)
                if (response?.success) {
                    this.conversa = response.data
                } else {
                    throw new Error('Erro ao carregar conversa')
                }
            }

           
            if (this.conversa.status == 3) {
               
                return
            }

           
            const EmAnalise = 1
            const AguardandoFornecedor = 2
            const novoStatus = this.$store.getters.isFornecedor ? AguardandoFornecedor : EmAnalise

           
            if (this.conversa.status !== novoStatus) {
                
                const response = await MensagensServicos.atualizarStatusConversa(conversaId, novoStatus)

                if (response?.success) {
                 
                    this.conversa.status = novoStatus
                    this.conversa.statusDescr = novoStatus === AguardandoFornecedor ? 
                        'Aguardando Fornecedor' : 'Em Análise'

                    this.$toast.success(
                        `Status da conversa atualizado para: ${this.conversa.statusDescr}`,
                        'OK',
                        this.$toastConfig.success
                    )
                    
                    
                    this.$emit('obterMensagensEConversasAtualizadas')
                }
            }
        } catch (error) {
            
            this.$toast.error(
                'Erro ao atualizar status da conversa',
                'ERROR',
                this.$toastConfig.error
            )
        }
        
    },
        async finalizarConversa() {
            try {
                const result = await this.$swal({
                    title: 'Finalizar Conversa',
                    text: 'Tem certeza que deseja finalizar esta conversa?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, Finalizar!',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6'
                })

                if (result.value) {
                    this.$store.dispatch('addRequest')
                    const response = await MensagensServicos.FinalizarConversa(this.conversa.conversaId)

                    if (response?.success) {
                        
                        this.$toast.success(
                            'Conversa finalizada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterMensagensEConversasAtualizadas')
                        this.$router.push({ name: 'Mensagens' })
                    } else {
                        throw new Error('Erro ao finalizar conversa')
                    }
                }
            } catch (error) {
               
                this.$toast.error(
                    'Erro ao finalizar conversa',
                    'ERROR',
                    this.$toastConfig.error
                )
            } finally {
                this.$store.dispatch('removeRequest')
            }
        },

        formatarData(data) {
            return new Date(data).toLocaleString()
        },

        isCurrentUser(userId) {
            return userId === this.$store.getters.usuario.usuarioId 
        },

        mostrarDestinatarios() {
            this.$bvModal.show('modal-destinatarios')
        }
    },

    created() {
         this.carregarConversa()
         this.AtualizarConversa()
    }
}
</script>

<style scoped>
.message-content {
    padding: 1rem;
    border-radius: 1rem;
    max-width: 80%;
    margin: 0.5rem 0;
}

.message-right {
    display: flex;
    justify-content: flex-end;
}

.message-left {
    display: flex;
    justify-content: flex-start;
}

.message-right .message-content {
    background-color: #DCF8C6;
   
}

.message-left .message-content {
    background-color: #E8E8E8;
   
}


.message-right .message-content {
    border-top-right-radius: 0.3rem;
}

.message-left .message-content {
    border-top-left-radius: 0.3rem;
}

.messages-container {
    max-height: 500px;
    overflow-y: auto;
    padding: 1rem;
    background-color: #F5F5F5;
   
}


.message-body {
    white-space: pre-wrap;
    word-break: break-word;
}

.message-body>>>p:last-child {
    margin-bottom: 0;
}

.message-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
}

.message-status {
    margin-top: 0.3rem;
    font-size: 0.8rem;
}

@media (max-width: 768px) {
    .message-content {
        max-width: 90%;
    }
}

.btn-danger {
    background-color: #dc3545;
    border-color: #dc3545;
}

.btn-danger:hover {
    background-color: #c82333;
    border-color: #bd2130;
}

/* Add new styles */
.modal-body p {
    margin-bottom: 0;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
}
destinatarios-modal {
    min-width: 90%;
}

.destinatarios-modal >>> .modal-dialog {
    max-width: 800px;
}

.destinatarios-modal >>> .modal-body {
    padding: 1.5rem;
}

.destinatarios-modal >>> .modal-body p {
    font-size: 1.1rem;
}destinatarios-modal {
    min-width: 90%;
}

.destinatarios-modal >>> .modal-dialog {
    max-width: 800px;
}

.destinatarios-modal >>> .modal-body {
    padding: 1.5rem;
}

.destinatarios-modal >>> .modal-body p {
    font-size: 1.1rem;
}
</style>